import React, { useEffect, useState } from 'react';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';

// Live online/offline badge for a paired physical device, reading
// devices/{deviceId}.lastSeenAt (fleet heartbeat: devices report every
// 2 min; online = seen < 5 min ago, computed at read time). Renders nothing
// when no physical device is paired or no heartbeat has arrived yet.
const ONLINE_WINDOW_MS = 5 * 60 * 1000;

const DeviceOnlineBadge = ({ deviceId, showVersion = true }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!deviceId) { setData(null); return undefined; }
    const db = getFirestore();
    const unsub = onSnapshot(doc(db, 'devices', deviceId), (snap) => {
      setData(snap.exists() ? snap.data() : null);
    }, (err) => console.warn('[DeviceOnlineBadge] listener error:', err.message));
    return () => unsub();
  }, [deviceId]);

  if (!deviceId || !data?.lastSeenAt) return null;
  const lastSeen = data.lastSeenAt.toDate ? data.lastSeenAt.toDate() : new Date(data.lastSeenAt);
  const online = (Date.now() - lastSeen.getTime()) < ONLINE_WINDOW_MS;
  const diffMs = Date.now() - lastSeen.getTime();
  const relative = diffMs < 60000 ? 'just now'
    : diffMs < 3600000 ? `${Math.floor(diffMs / 60000)}m ago`
    : diffMs < 86400000 ? `${Math.floor(diffMs / 3600000)}h ago`
    : lastSeen.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  return (
    <span
      className="badge badge-light text-dark"
      style={{ fontSize: '0.7rem', border: `1px solid ${online ? '#16a34a' : '#d1d5db'}`, color: online ? '#16a34a' : '#6b7280' }}
      title={`Last seen: ${lastSeen.toLocaleString()}${data.onlineSource ? ` · via ${data.onlineSource}` : ''}`}
    >
      <i className={`fas fa-circle mr-1`} style={{ fontSize: '0.5rem', color: online ? '#16a34a' : '#9ca3af' }}></i>
      {online ? 'Online' : `Offline · ${relative}`}
      {showVersion && data.appVersion ? ` · v${data.appVersion}` : ''}
    </span>
  );
};

export default DeviceOnlineBadge;
